import { render, staticRenderFns } from "./MoreFilters.vue?vue&type=template&id=0d8b6c1e&scoped=true"
import script from "./moreFilters.ts?vue&type=script&lang=ts&external"
export * from "./moreFilters.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8b6c1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d8b6c1e')) {
      api.createRecord('0d8b6c1e', component.options)
    } else {
      api.reload('0d8b6c1e', component.options)
    }
    module.hot.accept("./MoreFilters.vue?vue&type=template&id=0d8b6c1e&scoped=true", function () {
      api.rerender('0d8b6c1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/explore/top-filter/more-filters/MoreFilters.vue"
export default component.exports